/* global ViewController, WebView */
var safeShareController = new ViewController({
    directory : "views/public",
    name: "safeShare",
    container: "main",
    route: "safe-share"
}) ;

safeShareController.prepareDataOnEnter = function(token, callback){
    var self = this ;
    var path = "" ;
    let safeId = Number(window.location.hash.split("$")[2]) ;
    var indexSlash = token.indexOf("/") ;
    if(indexSlash !== -1){
        path = token.substring(indexSlash) ;
        token = token.substring(0, indexSlash) ;
    }
    var data = {
        token: token,
        path: path,
        safeId: safeId,
    } ;

    self._sharePasswords = self._sharePasswords || {} ;

    self.api.public.getSafeShareSettings(function(err, settings){
        if(err){ return callback(err) ; }
        if(settings.attach){
            data.hasCustomBg = true ;
        }

        var promptPassword = function(showError){
            // One prompt at a time: a concurrent enter must not stack a 2nd popup.
            if(self._sharePasswordPopup){
                if(showError && self._sharePasswordPopup.EL.wrongPasswordAlert){
                    self._sharePasswordPopup.EL.wrongPasswordAlert.classList.remove("d-none") ;
                }
                return ;
            }
            var viewChange = new WebView("views/public", "docSharePasswordPopup") ;
            self._sharePasswordPopup = viewChange ;
            viewChange.openInPopup({
                title: '',
                aboveAll: true
            }, function(){
                if(showError && viewChange.EL.wrongPasswordAlert){
                    viewChange.EL.wrongPasswordAlert.classList.remove("d-none") ;
                }
            }) ;
            viewChange.on("close", function(){ self._sharePasswordPopup = null ; }) ;
            viewChange.on("validate", function(){
                var passData = viewChange.getData() ;
                viewChange.close() ;
                self._sharePasswordPopup = null ;
                loadDocuments(passData.share_password, true) ;
            }) ;
        } ;

        var loadDocuments = function(password, isUserAttempt){
            self.api.public.getSafeShareDocuments(token, path, password, function(err, result){
                if(err){
                    if(err === "EXPIRED"){ return callback(null, { expired: true }) ; }
                    if(err === "NOT_FOUND"){ return callback(null, { notfound: true }) ; }
                    if(err === "NEED_PASSWORD" || err === "WRONG_PASSWORD"){
                        // A parallel flow may have validated the password by now:
                        // reuse it silently rather than re-prompt.
                        var cached = self._sharePasswords[token] ;
                        if(cached && cached !== password){
                            return loadDocuments(cached, false) ;
                        }
                        // Only flag the error for a wrong password the user typed.
                        return promptPassword(err === "WRONG_PASSWORD" && isUserAttempt) ;
                    }
                    return callback(err) ;
                }
                self._sharePasswords[token] = password ;
                data.result = result ;
                data.password = password ;
                result.folders.forEach(function(folder){
                    folder.name = folder.path.substring(folder.path.lastIndexOf("/")+1) ;
                }) ;
                callback(null, data) ;
            }) ;
        } ;

        loadDocuments(self._sharePasswords[token], false) ;
    }) ;
};

safeShareController.onFolder = function(ev){
    var folder = ev.data.data ;
    this.updateRouteData(this.viewOptions.route, this.data.token+"/"+folder.path) ;
} ;

safeShareController.onDownload = function(ev){
    this.view.longTask(function(done){
        this.api.public.downloadSafeSharedDocument(this.data.token,
            ev.data.data.id,
            this.data.password
        , function(err){
            if(err){ return done(err) ;}
            this.refresh(done) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = safeShareController ;